export const CURRENT_USER_QUERY_KEY = "user::current"
export const CURRENT_USER_ENDPOINT = "/api/users/v1/current_user"

export const CURRENT_USER_SEARCH_CONFIG_QUERY_KEY = "user::current::searchConfig"
export const CURRENT_USER_SEARCH_CONFIG_ENDPOINT =
  "/api/users/v1/current_user/search_configs/job_offers?include=search_filters"

export const CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY = "user::current::searchCriteria"
export const CURRENT_USER_SEARCH_CRITERIA_ENDPOINT = "/student_profiles/v2/search_criteria"
